import englishMessages from 'ra-language-english';

const customMessages = {
  ...englishMessages,
  app: {
    title: 'Credco Marketing',
  },
  resources: {
    messageinbox: {
      name: 'Message |||| Messages',
    },
    inquiries: {
      name: 'Inquiry |||| Inquiries',
    },
    customercontacts: {
      name: 'Contact Enquiry |||| Contact Enquiries',
    },
    marketlistingleads: {
      name: 'Market listing lead |||| Market listing leads',
    },
  },
  pos: {
    menu: {
      dashboard: 'Dashboard',
      customers: 'Customer |||| Customers',
    },
  },
  menu: {
    inquiry: 'Inquiry',
    inquiry_inbox: 'Inquiry Inbox',
    inbox: 'Inbox',
    whatsapp: 'WhatsApp',
    website: 'Website',
    message_inbox: 'Message Inbox',
  },
};

export default customMessages;
